import { render } from "./UserInformationView.vue?vue&type=template&id=6dff69b0"
import script from "./UserInformationView.vue?vue&type=script&lang=js"
export * from "./UserInformationView.vue?vue&type=script&lang=js"

import "./UserInformationView.vue?vue&type=style&index=0&id=6dff69b0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__